import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { API_PATH } from 'src/environments/environment';
import { AbstractCrudService } from '../../../shared/components/crud/abstract-crud.service';
import { RELATIVE_URL } from './crud-config';

@Injectable()
export class SystemService extends AbstractCrudService {

  constructor(protected override httpClient: HttpClient) {
    super(httpClient, RELATIVE_URL);
  }

  public findByName(name: string): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byName/${name}`
    );
  }

  public findByType(type: number): Observable<Object> {
    return this.httpClient.get<Object>(
      `${API_PATH}${this.relativeUrl}/byType/${type}`
    );
  }

  public findByFilter(filterForm: any, pagination: any): Observable<any[]> {
    let params = {
      ...{ getRelation: 0, limit: 36, page: 0, filter: '' },
      ...pagination,
    };

    return this.httpClient.post<any[]>(
      `${API_PATH}${this.relativeUrl}/filter`,
      { ...filterForm, ...params }
    );
  }

  /**
   * Método direto para buscar os dados do sistema e também o template associado.
   * Esta abordagem garante que os dados do template sejam corretamente carregados.
   */
  public getSystemWithTemplate(id: string): Observable<any> {
    return this.httpClient.get<any>(`${API_PATH}${this.relativeUrl}/${id}`)
      .pipe(
        tap(system => {
          if (system.contractTemplateUrl && !system.contractTemplateUrl.startsWith('http')) {
            if (!system.contractTemplateUrl.includes('CONTRACT_TEMPLATES/')) {
              system.contractTemplateUrl = `CONTRACT_TEMPLATES/${system.contractTemplateUrl}`;
            }
          }
        })
      );
  }
}
